import {purchaseOrderItemsPivotTableKey} from 'reducers/purchasingContext/selected'
import {getAllRows} from 'selectors/pivotTable'
import {get, last} from 'lodash'
import {getDefaultEntityId} from 'selectors/contacts'

export const getSelectedCompanyId = state => get(state, 'purchasingContext.selected.companyId')
export const getSelectedContactId = state => state.purchasingContext.selected.contactId
export const getPurchaseOrders = state => state.purchasingContext.purchaseOrders
export const getPurchaseOrderSelectedState = state => state.purchasingContext.selected
export const getSelectedPurchaseOrder = state => state.purchasingContext.selected.purchaseOrder
export const getSelectedPurchaseOrderId = state => get(state.purchasingContext.selected.purchaseOrder, 'id')
export const getSelectedPurchaseOrderItems = state => getAllRows(state, purchaseOrderItemsPivotTableKey)
export const getDeletedPurchaseOrderItems = state => state.purchasingContext.selected.deletedItems
export const getSelectedCurrentTab = state => state.purchasingContext.selected.currentTab || 'order'
export const getLastPurchaseOrder = state => last(state.purchasingContext.selected.changeLogOrder)
export const getLastPurchaseOrderItems = state => last(state.purchasingContext.selected.changeLogOrderItems)
export const getSelectedPurchaseOrderCurrentFolder = state => state.purchasingContext.selected.currentFolder
export const getSelectedPurchaseOrderDocuments = state => state.purchasingContext.selected.documents.data.data
export const getNewSelectedPurchaseOrderDocuments = state => state.purchasingContext.selected.newDocuments.data.data

export const getPurchaseOrderSelector = state => state.purchasingContext.selector
export const getPurchaseOrderItemDrawer = state => state.purchasingContext.itemDrawer

export const getDefaultPurchaseOrderId = state => {
  const contactId = getSelectedContactId(state)
  const companyId = getSelectedCompanyId(state)
  return getDefaultEntityId(
      state,
      contactId,
      companyId,
      'recentContactPurchaseOrders',
      'recentCompanyPurchaseOrders',
      'latestPurchaseOrder'
  )
}

export const getSelectedPurchaseInvoiceEditor = state => state.purchasingContext.selectedPurchaseInvoice
export const getSelectedPurchaseInvoice = state => state.purchasingContext.selectedPurchaseInvoice.purchaseInvoice
export const getSelectedPurchaseInvoiceItemDrawer = state =>
    state.purchasingContext.selectedPurchaseInvoice.purchaseInvoiceItemDrawer
export const getPurchaseTotal = state => state.purchasingContext.purchaseOrders.total

export const getSelectedPurchaseOrderDocumentSubFolder = state => state.purchasingContext.selected.subFolder
export const getSelectedCurrentDetailsTab = state => state.purchasingContext.selected.currentDetailsTab || 'Order'
